const C = {
  name: "Retail",
  dimensions: { width: 24, height: 24 },
  content: `
    <path fill-rule="evenodd" clip-rule="evenodd" d="M10 2C8.89228 2 8 2.89228 8 4C8 4.55228 7.55228 5 7 5C6.44772 5 6 4.55228 6 4C6 1.78772 7.78772 0 10 0C12.2123 0 14 1.78772 14 4C14 5.86687 12.727 7.4314 11 7.87445V9.41174L18.4556 13.5558C18.4557 13.5559 18.4556 13.5558 18.4556 13.5558C19.4005 14.0808 20 15.084 20 16.18V17C20 18.6523 18.6523 20 17 20H3C1.34772 20 0 18.6523 0 17V16.18C0 15.0928 0.581954 14.0837 1.5468 13.5545L9 9.41174V7C9 6.44772 9.44771 6 10 6C11.1077 6 12 5.10772 12 4C12 2.89228 11.1077 2 10 2ZM10 11.1441L2.50982 15.3074C2.1967 15.4786 2 15.8085 2 16.18V17C2 17.5477 2.45228 18 3 18H17C17.5477 18 18 17.5477 18 17V16.18C18 15.816 17.7994 15.4792 17.4844 15.3042L10 11.1441Z" fill="currentColor"/>
    `
};
export {
  C as Retail
};
